"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _coreThemes = require("@vfuk/core-themes");
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreHeading = _interopRequireDefault(require("@vfuk/core-heading"));
var _coreCollapsibleContainer = require("@vfuk/core-collapsible-container");
var _coreLinkWithIcon = _interopRequireDefault(require("@vfuk/core-link-with-icon"));
var Styled = _interopRequireWildcard(require("./styles/ListSlot.style"));
var _ListSlot2 = _interopRequireDefault(require("./themes/ListSlot.theme"));
var _ListItem = _interopRequireDefault(require("./components/ListItem"));
var _SlotWrapper = _interopRequireDefault(require("../../SlotWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /*eslint-disable complexity */
var ListSlot = function ListSlot(_ref) {
  var heading = _ref.heading,
    items = _ref.items,
    _ref$showToggle = _ref.showToggle,
    showToggle = _ref$showToggle === void 0 ? true : _ref$showToggle,
    _ref$isInitiallyOpen = _ref.isInitiallyOpen,
    isInitiallyOpen = _ref$isInitiallyOpen === void 0 ? false : _ref$isInitiallyOpen,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    collapsibleContainer = _ref.collapsibleContainer,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 1 : _ref$size,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 1 : _ref$columns,
    slotWrapper = _ref.slotWrapper,
    localTheme = _ref.localTheme,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _useState = (0, _react.useState)(isInitiallyOpen || false),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var componentName = 'ListSlot';
  var listSlotTheme = (0, _coreThemes.useLocalTheme)(componentName, _ListSlot2["default"], localTheme);
  var _ref2 = inverse ? listSlotTheme.appearance[appearance].inverse : listSlotTheme.appearance[appearance],
    inverseIcon = _ref2.inverseIcon,
    inverseText = _ref2.inverseText;
  var onToggle = function onToggle() {
    setIsActive(!isActive);
  };
  var toggleLinkText = (0, _react.useMemo)(function () {
    if (collapsibleContainer && collapsibleContainer.headerText) {
      var _collapsibleContainer = collapsibleContainer.headerText,
        activeText = _collapsibleContainer.activeText,
        inactiveText = _collapsibleContainer.inactiveText;
      return {
        activeText: activeText,
        inactiveText: inactiveText
      };
    }
    return {
      activeText: t('Close'),
      inactiveText: t('Open')
    };
  }, [collapsibleContainer === null || collapsibleContainer === void 0 ? void 0 : collapsibleContainer.headerText, i18n.language]);
  var listIsCollapsible = showToggle && (columns === 1 && items.length > 3 || columns === 2 && items.length > 6);
  var collapsingIndex = columns === 1 ? 3 : 6;
  return /*#__PURE__*/_react["default"].createElement(_SlotWrapper["default"], _extends({}, slotWrapper, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }), /*#__PURE__*/_react["default"].createElement(Styled.ListSlot, null, /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], _extends({}, heading, {
    inverse: inverseText,
    size: 1,
    weight: 3,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading')
  })), listIsCollapsible ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Styled.ListItemsWrapper, {
    columns: columns
  }, items.slice(0, collapsingIndex).map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], _extends({
      key: "list-item-".concat(index)
    }, item, {
      appearance: appearance,
      inverse: inverse,
      size: size,
      localTheme: listSlotTheme,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "list-item-".concat(index))
    }));
  })), /*#__PURE__*/_react["default"].createElement(Styled.CollapsibleListWrapper, {
    isActive: isActive
  }, /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainer, {
    isActive: isActive,
    onToggle: onToggle,
    icons: {
      activeIcon: 'minus',
      inactiveIcon: 'plus'
    },
    inverse: inverseIcon && inverseText,
    width: "auto",
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'collapsible-container')
  }, /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainerBody, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'collapsible-container-body')
  }, /*#__PURE__*/_react["default"].createElement(Styled.ListItemsWrapper, {
    columns: columns
  }, items.slice(collapsingIndex).map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], _extends({
      key: "list-item-".concat(index + collapsingIndex)
    }, item, {
      appearance: appearance,
      inverse: inverse,
      size: size,
      localTheme: listSlotTheme,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "list-item-".concat(index + collapsingIndex))
    }));
  }))))), /*#__PURE__*/_react["default"].createElement(Styled.ToggleLinkWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreLinkWithIcon["default"], {
    appearance: "secondary",
    inverse: inverseText,
    icon: {
      name: isActive ? 'minus' : 'plus'
    },
    text: isActive ? toggleLinkText.activeText : toggleLinkText.inactiveText,
    onClick: onToggle,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'toggle-link')
  }))) : /*#__PURE__*/_react["default"].createElement(Styled.ListItemsWrapper, {
    columns: columns
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], _extends({
      key: "list-item-".concat(index)
    }, item, {
      appearance: appearance,
      inverse: inverse,
      size: size,
      localTheme: listSlotTheme,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "list-item-".concat(index))
    }));
  }))));
};
ListSlot.displayName = "ListSlot";
var _default = ListSlot;
exports["default"] = _default;
//# sourceMappingURL=ListSlot.js.map